import api from './api';

export type PlatformCategory = 'blog' | 'traffic' | 'seo' | 'custom';
export type PlatformAutomationLevel = 'direct_api' | 'oauth_or_token' | 'not_available';

export interface PlatformCredentialField {
  key: string;
  label: string;
  placeholder?: string;
  helpText?: string;
  type: 'text' | 'password' | 'url';
  required: boolean;
  secret?: boolean;
}

export interface ContentPlatformDefinition {
  id: string;
  name: string;
  website: string;
  category: PlatformCategory;
  description: string;
  automationLevel: PlatformAutomationLevel;
  supportsBulkPublish: boolean;
  requiredFields: PlatformCredentialField[];
}

export interface SyndicationPublishRequest {
  title: string;
  content: string;
  canonicalUrl?: string;
  tags: string[];
  selectedPlatformIds: string[];
  platformCredentials: Record<string, Record<string, string>>;
}

export interface PlatformPublishResult {
  platformId: string;
  platformName: string;
  status: 'published' | 'failed' | 'skipped';
  message: string;
  externalUrl?: string;
  postId?: string;
}

export interface SyndicationPublishResponse {
  message: string;
  summary: {
    requested: number;
    published: number;
    failed: number;
    skipped: number;
  };
  results: PlatformPublishResult[];
}

export interface SyndicationCredentialsResponse {
  platformCredentials: Record<string, Record<string, string>>;
}

export const getContentPlatforms = async (): Promise<ContentPlatformDefinition[]> => {
  const response = await api.get('/admin/content-syndication/platforms');
  return response.data.platforms;
};

export const getSyndicationCredentials = async (): Promise<Record<string, Record<string, string>>> => {
  const response = await api.get<SyndicationCredentialsResponse>('/admin/content-syndication/credentials');
  return response.data.platformCredentials || {};
};

export const updateSyndicationCredentials = async (
  platformCredentials: Record<string, Record<string, string>>
): Promise<Record<string, Record<string, string>>> => {
  const response = await api.put<SyndicationCredentialsResponse>('/admin/content-syndication/credentials', {
    platformCredentials,
  });
  return response.data.platformCredentials || {};
};

export const publishSyndicatedContent = async (
  payload: SyndicationPublishRequest
): Promise<SyndicationPublishResponse> => {
  const response = await api.post('/admin/content-syndication/publish', payload);
  return response.data;
};
